import { component, computed, observable } from 'knockout-decorators'
import { CartState } from '../state'

import ArrowIcon from '~/images/arrow-right.svg?raw'
import CouponIcon from '~/images/coupon.svg?raw'
import xmarkIcon from '~/images/icons/heroicons/xmark.svg?raw'

import source from './template.html?raw'
import { PageState } from '~/store/page'

import './styles.css'

@component('cart-coupon', source)
export class CartCoupon {
  private cartState: CartState = CartState.get()
  private pageState = PageState.get()

  @observable public couponInput = ''
  @observable public submittedCoupon = ''
  @observable public error = ''
  @observable public isLoading = false
  @observable public isSubmitted = false

  arrowIcon = ArrowIcon
  couponIcon = CouponIcon
  clearIcon = xmarkIcon

  @computed get allowCartCoupons(): boolean {
    return this.cartState.content?.allowAddingCoupon ?? false
  }

  @computed get isValid(): boolean {
    return this.cartState.content?.coupon === this.couponInput
  }

  @computed get isInvalid(): boolean {
    return !this.isLoading && !this.isValid
  }

  @computed get hasError(): boolean {
    return !this.isLoading && this.error.length > 0
  }

  couponFieldInput = () => {
    if (this.hasError) {
      this.error = ''
    }
  }

  async removeCoupon() {
    if (!this.isLoading) {
      this.isLoading = true

      const result = await this.cartState.removeCoupon(this.submittedCoupon)

      if (typeof result === 'string') {
        console.error(result)
        this.error = result
      } else {
        this.error = ''
        this.submittedCoupon = ''
        this.isSubmitted = false
      }

      this.isLoading = false
    }
  }

  async applyCoupon() {
    if (!this.isLoading) {
      this.isLoading = true

      const result = await this.cartState.applyCoupon(this.couponInput)

      if (typeof result === 'string') {
        console.error(result)
        this.error = result
      } else {
        this.submittedCoupon = this.couponInput
        this.couponInput = ''
        this.isSubmitted = true
        this.error = ''
      }

      this.isLoading = false
    }
  }
}
